import React, { useEffect } from "react";
import Highcharts from "highcharts";
import Highmaps from "highcharts/modules/map";
import "../WorldMapChart/WorldMapChart.css";

// Initialize the map module
// Highmaps(Highcharts);

const WorldMapChart = () => {
  useEffect(() => {
    const fetchData = async () => {
      // Fetch the map data
      const topology = await fetch(
        "https://code.highcharts.com/mapdata/custom/world.topo.json"
      ).then((response) => response.json());

      const data = [
        [
          "New York Stock Exchange",
          "USA",
          "2022",
          40.71,
          -74.01,
          2500,
          3000,
          2800,
          2700,
        ],
        [
          "London Stock Exchange",
          "UK",
          "2022",
          51.51,
          -0.12,
          2400,
          2900,
          2700,
          2600,
        ],
        [
          "Tokyo Stock Exchange",
          "Japan",
          "2022",
          35.68,
          139.76,
          2200,
          2700,
          2500,
          2400,
        ],
        [
          "Shanghai Stock Exchange",
          "China",
          "2022",
          31.23,
          121.47,
          2100,
          2500,
          2300,
          2200,
        ],
        [
          "Euronext Paris",
          "France",
          "2022",
          48.85,
          2.35,
          2100,
          2600,
          2400,
          2300,
        ],
        [
          "Frankfurt Stock Exchange",
          "Germany",
          "2022",
          50.11,
          8.68,
          2300,
          2800,
          2600,
          2500,
        ],
        ["BSE Sensex", "India", "2022", 19.08, 72.86, 2400, 2900, 2700, 2600],
        ["NASDAQ", "USA", "2022", 40.73, -73.94, 2600, 3100, 2900, 2800],
        [
          "Toronto Stock Exchange",
          "Canada",
          "2022",
          43.65,
          -79.38,
          2200,
          2700,
          2500,
          2400,
        ],
        [
          "Australian Stock Exchange",
          "Australia",
          "2022",
          -33.86,
          151.21,
          2000,
          2500,
          2300,
          2200,
        ],
        ["Bovespa", "Brazil", "2022", -23.55, -46.63, 2100, 2600, 2400, 2300],
      ];

      // Highcharts map initialization
      Highcharts.mapChart("container", {
        chart: {
          map: topology,
          backgroundColor: "#f8f8f7"
        },
        title: {
          text: "World Stock Exchanges", // Example chart title
          style: { fontSize: "16px", color: "#999" },
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom",
            style: { fontSize: "16px", color: "#999" },
          },
        },
        mapView: {
          fitToGeometry: {
            type: "MultiPoint",
            coordinates: [
              [-164, 54], // Alaska west
              [-35, 84], // Greenland north
              [179, -38], // New Zealand east
              [-68, -55], // Chile south
            ],
          },
        },
        tooltip: {
          headerFormat: "",
          pointFormat:
            "{point.city} ({point.country}, {point.year})<br/>" +
            "Total medals: {point.z}<br/>" +
            '<span style="color: #ffd700;">\u25CF</span> {point.gold}<br/>' +
            '<span style="color: #c0c0c0;">\u25CF</span> {point.silver}<br/>' +
            '<span style="color: #cd7f32;">\u25CF</span> {point.bronze}<br/>',
          style: { fontSize: "16px", color: "#999" }, // Updated tooltip text style
        },
        series: [
          {
            name: "World map",
            nullColor: "#c7d7fe",
          },
          {
            name: "Stock Exchanges",
            type: "mapbubble",
            color: "#fdcc71",
            lineWidth: 1,
            keys: [
              "city",
              "country",
              "year",
              "lat",
              "lon",
              "z",
              "gold",
              "silver",
              "bronze",
            ],
            data: data,
            minSize: "5%",
            maxSize: "12.5%",
            dataLabels: {
              enabled: true,
              style: {
                color: "rgb(0 0 0)",       // Black text color
                fontSize: "12px",          // Small font size
                fontWeight: "normal",      // Normal font weight
                fill: "rgb(0 0 0)",        // Black fill color
                letterSpacing: "1px",      // Adds slight letter spacing
                textShadow: "none",        // Explicitly removes text shadow
              },
            },
            
            accessibility: {
              point: {
                valueDescriptionFormat:
                  "{point.city}, {point.country}, {point.year}. " +
                  "Total medals: {point.z}. Gold: {point.gold}, silver: {point.silver}, bronze: {point.bronze}.",
              },
            },
          },
        ],
      });
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="section">
        <div className="full-world-container">
          <div className="full-world-header">
            <h1>Global Stock Market Overview</h1>
          </div>

          <div className="full-world-parent">
            <div className="full-world-chart-container">
              <div id="container"></div>
            </div>
            <div className="full-world-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#c7d7fe" }}
                      ></i>{" "}
                      {/* Yellow for Process */}
                    </td>
                    <td>Stock Exchange</td> {/* Description for yellow */}
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#fdcc71" }}
                      ></i>{" "}
                      {/* Blue for Review */}
                    </td>
                    <td>Report Value</td> {/* Description for blue */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorldMapChart;
